import { Routes, Route } from 'react-router-dom'
import Navbar from './components/Navbar'
import Footer from './components/Footer'
import Home from './pages/Home'
import Services from './pages/Services'
import Platform from './pages/Platform'
import About from './pages/About'
import Contact from './pages/Contact'
import DemoIndex from './pages/DemoIndex'
import DemoPage from './pages/DemoPage'

function App() {
  return (
    <>
      <Navbar />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/platform" element={<Platform />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/demo" element={<DemoIndex />} />
          <Route path="/demo/:agentSlug" element={<DemoPage />} />
        </Routes>
      </main>
      <Footer />
    </>
  )
}

export default App
